import { useEffect, useState } from 'react';
import { EventBus } from '@vtblife/event-bus';
const eventBus = EventBus.getInstance();
export const DEFAULT_REGION = {
    userRegionId: 3,
    userRegionName: 'Москва',
};
const eventTypes = [
    { type: 'userRegion:change', category: 'simple' },
    { type: 'userRegion:init', category: 'behavior' },
    { type: 'userRegion:update', category: 'behavior' },
];
export function useUserRegion(defaultRegion) {
    const [region, setRegion] = useState(defaultRegion);
    useEffect(() => {
        const subscriptions = eventTypes.map(({ type, category }) => {
            const subscription = eventBus.subscribe(type, (event) => {
                setRegion(event.data);
            }, {
                eventCategory: category,
            });
            return subscription;
        });
        return () => subscriptions.forEach((sub) => sub.unsubscribe());
    }, []);
    return region;
}
//# sourceMappingURL=use-user-region.js.map